import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import TwetchLogo from 'assets/twetch-logo.jpg'

export interface TwetchIconProps {
    contextStyles?: string
    hoverStyles?: string
    selectedStyles?: string
    initialStyles?: string
}

export default function TwetchIcon({
    contextStyles,
    hoverStyles,
    selectedStyles,
}: TwetchIconProps) {
    return (
        <div className={cn(contextStyles, hoverStyles, selectedStyles, styles.twetchIcon)}>
            <img src={TwetchLogo} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
    )
}
